<template>
    <!-- 全球支付网络 -->
    <main-page :title="title" :subtitle="subtitle" :description="description" :button-text="buttonText" :bg="bg" />
</template>
<script>
import MainPage from "./components/MainPage.vue";
export default {
    name: "network",
    components: {
        MainPage
    },
    data() {
        return {
            bg: "/img/pay/bg6.png",
        }
    },
    computed: {
        title() {
            return this.$t('network.title');
        },
         subtitle() {
            return this.$t('network.subtitle');
        },
        description() {
            return this.$t('network.description');
        },
        buttonText() {
            return this.$t('common.buttonText');
        },
    }
};
</script>
<style lang="scss" scoped></style>